module.exports = __webpack_public_path__ + "static/Universidad-7ffa671c3f93c7664b2717283eb27d7a.jpg";